import React from 'react';
import Fetch from '../components/Fetch';
import ArticleList from '../components/ArticleList';

export default function Video() {
  return (
    <div className="video-page" style={{ padding: '20px' }}>
      <h1>Video</h1>
      <Fetch>
        {({ data, loading, error }) => {
          const videos = data?.filter(item => item.content_type === 'igtt') || [];
          const sortedVideos = videos.sort((a, b) => new Date(b.date_created) - new Date(a.date_created));
          return <ArticleList articles={sortedVideos} />;
        }}
      </Fetch>
    </div>
  );
}
  